import { PRODUCT_TERMS } from '../../../constants/productTerminology';

export function normalizeDiscoveryResultToPrompt(result = {}) {
  const item = result.prompt || result.raw || result;
  const title = result.name || result.title || item.title || item.name || PRODUCT_TERMS.capability.untitled;
  // Assistant ranking retains the resolved owner on the result even when a
  // compact search hit does not include its nested author object.
  const authorName = item.author?.name || result.author?.name || item.userName || result.userName
    || item.owner || result.owner || item.ownerName || result.ownerName
    || item.createdByName || result.createdByName || item.creatorName || result.creatorName;
  const authorId = item.author?.id || result.author?.id || item.userId || result.userId
    || item.createdBy || result.createdBy || item.ownerId || result.ownerId;
  const authorEmail = item.author?.email || result.author?.email || item.userEmail || result.userEmail;
  return {
    ...item,
    id: item.id || result.id,
    title,
    name: title,
    description: result.description || item.description || '',
    category: result.category || item.category || result.capabilityType || item.capabilityType,
    capabilityType: result.capabilityType || item.capabilityType,
    hasAccess: item.hasAccess !== false,
    author: authorName ? {
      name: authorName,
      id: authorId,
      email: authorEmail,
    } : item.author || (item.userName || item.userId
      ? {
        name: item.userName,
        id: item.userId,
        email: item.userEmail,
      }
      : undefined),
    userName: authorName || item.userName,
    userId: authorId || item.userId,
    collection: item.collection,
    collectionId: item.collectionId,
    collectionName: item.collectionName,
    stats: item.stats,
    likes: item.likes,
    favorites: item.favorites,
    usage: item.usage,
    createdAt: item.createdAt,
    updatedAt: item.updatedAt,
  };
}

function legacyRecommendationLines(value) {
  return String(value || '')
    .split(/\n+/)
    .map((line) => line.replace(/^\s*(?:[-*•]|\d+[.)])\s+/, '').trim())
    .filter(Boolean);
}

export function getDiscoveryMatchDetails(result = {}, fallback = '') {
  const legacyLines = legacyRecommendationLines(result.recommendation);
  const rationale = String(result.rationale || legacyLines[0] || fallback || '').trim();
  const adaptationGap = String(result.adaptationGap || '').trim();
  return { rationale, adaptationGap };
}

export { normalizeDiscoveryResultToContext } from '../../prompt-builder/createFlow/knowledgeDiscoveryUtils';
